
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"7.462","height":"14.244"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.35 14.244a.329.329 0 00.233-.1l6.779-6.781a.339.339 0 000-.479L.583.105a.339.339 0 10-.479.479l6.54 6.54-6.54 6.54a.338.338 0 00-.075.375.334.334 0 00.321.205z","fill":"#949c7c"}})])
          )
        }
      }
    